if (!customElements.get('collection-body')) {
  class CollectionBody extends HTMLElement {
    selectors = {
      trigger: '[collection-body="trigger"]',
      productsContainer: '[collection-body="product-container"]',
      productCard: '[collection-body="product-container"] .card-product',
    };

    BULK_LOAD_PAGES_LIMIT = 5; // Limit for bulk loading pages

    constructor() {
      super();
    }

    connectedCallback() {
      this.elements = {
        trigger: this.querySelector(this.selectors.trigger),
        productsContainer: this.querySelector(this.selectors.productsContainer),
      };

      if (!this.elements.trigger || !this.elements.productsContainer) return;

      this.prevOpenedPage = Number(sessionStorage.getItem("collectionOpenedPage")) || null;

      this.currentPage = Number(this.elements.trigger.dataset.currentPage);
      this.totalPages = Number(this.elements.trigger.dataset.totalPages);
      this.baseUrl = this.elements.trigger.dataset.url;

      this.bulkLoadPages();


      if (this.currentPage == this.totalPages) {
        this.elements.trigger.style.display = 'none';
      }

      this.elements.trigger.addEventListener('click', this.handleTriggerClick.bind(this));
    }

    reloadPages() {
      this.updateReferences();
      this.bulkLoadPages();
    }

    updateReferences() {
      this.elements = {
        trigger: this.querySelector(this.selectors.trigger),
        productsContainer: this.querySelector(this.selectors.productsContainer),
      };

      this.elements.trigger.addEventListener('click', this.handleTriggerClick.bind(this));

      this.currentPage = Number(this.elements.trigger.dataset.currentPage);
      this.totalPages = Number(this.elements.trigger.dataset.totalPages);
      this.baseUrl = this.elements.trigger.dataset.url;
    }

    handleTriggerClick() {
      const nextPage = this.currentPage + 1;

      this.loadNextPage(nextPage);
    }

    bulkLoadPages() {
      if (this.prevOpenedPage && this.prevOpenedPage <= this.totalPages) {
        for (let index = this.currentPage + 1; index <= this.prevOpenedPage; index++) {
          if (index > this.BULK_LOAD_PAGES_LIMIT) {
            return; // Stop if we exceed the bulk load limit
          }

          this.loadNextPage(index, false);
        }
      }
    }

    loadNextPage(nextPage, updateSession = true) {
      fetch(`${this.baseUrl}&page=${nextPage}`)
        .then(res => res.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newProducts = doc.querySelectorAll(this.selectors.productCard);

          newProducts.forEach(product => {
            this.elements.productsContainer.appendChild(product);
          });

          // Update current page
          this.currentPage = nextPage;
          updateSession && sessionStorage.setItem("collectionOpenedPage", this.currentPage);

          // Hide button if last page
          if (nextPage >= this.totalPages) {
            this.elements.trigger.style.display = 'none';
          }
        })
        .catch(err => {
          console.error('Error loading more products:', err);
        });
    }
  }
  customElements.define('collection-body', CollectionBody);
}
